module.exports = __webpack_public_path__ + "static/media/blog-13(graph).2117e5f8.svg";